/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-08-10 14:21:39
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-09-01 11:33:59
 */
import {
    AddTalkList,
    GetFriendList,
    GetFriendApplication,
    AddUserCache,
    ChangeActiveRoomName
} from '../../../../store/actionCreators'
import axios from 'axios';
import store from '../../../../store';
import {message} from 'antd';
import {customlog} from '../../../../utils/tools';
import {dispatchmessage} from '../../../../service/loginaction';
import pinyin from 'pinyin'

// import { TalkEntityRec } from '../../../modules/receiveEntity';
// import { ReceiveMesssgeEntity, TalkEntity } from 'src/modules/localEntity';
let global2 = global
// ****************************************************************
// *******   *****   ************  ***********************   ******
// **   ***  *****          *****  ******        *   *****   ******
// ***          **  *****   *           ***   **     *           **
// ****               **   *****   ********          **         ***
// *    *       *     **  ******   *******   *       *****   ******
// **        ****  *         ***       ***  *                     *
// **        ****     **  *****    *  ***            ****    *  ***
// **     *  *  **   ***  ****        ******   *     **          **
// **          ***    **  ***   **   *******   ***   *         ****
// **   **     **      *  ***  **      ****   ****   * **        **
// **      **      ***    ****    ***        ****    ***   ****   *
// ****************************************************************
//调用后台接口 读取好友列表
export const loadfriendList = async (user) => {

    // debugger
    if (!user) {
        user = store.getState().userReducer.get('user').toJS()
    }
    customlog('读取好友列表', 'start')
    const {data: res} = await axios.get(`${global2.serviceUrl.chat}/friend/${user.userId}`)
    if (res.code === "200") {
        let friendList = res.payload;
        friendList.forEach((data) => {
            data.avatar = global.yunguanAvatar + '/' + data.avatar
        })
        console.log('loadfriendList时的friendList：',friendList.slice(0, 3));
        let friendListSimple = getFirstChar(friendList)
        friendListSimple.sort((a, b) => pinyin.compare(a.userName, b.userName))
        store.dispatch(GetFriendList(friendListSimple))
        friendList.forEach((frined) => {
            let user //= new User()
            user = {
                userId: frined.friendInfo.userId,
                userName: frined.friendInfo.userName,
                avatar: frined.friendInfo.avatar,
                phone: frined.friendInfo.phone,
            }
            store.dispatch(AddUserCache(user))
        })
        customlog('读取完成好友列表', 'end')
    }
    // axios.get(`${global2.serviceUrl.chat}/friend/${user.userId}`).then(res => {
    //     let friendList = res.data.payload
    //     let friendListSimple = getFirstChar(friendList)
    //     friendListSimple.sort((a, b) => pinyin.compare(a.userName, b.userName))
    //     // sortName(friendListSimple)
    //     store.dispatch(GetFriendList(friendListSimple))
    //     friendList.forEach((frined) => {
    //         let user //= new User()
    //         user = {
    //             userId: frined.friendInfo.userId,
    //             userName: frined.friendInfo.userName,
    //             avatar: frined.friendInfo.avatar,
    //             phone: frined.friendInfo.phone,
    //         }
    //         store.dispatch(AddUserCache(user))
    //     })
    //     customlog('读取完成好友列表', 'end')
    // }).catch((e) => {
    //     //------------------------------------------------------------------------
    //     //------------------------------------------------------------------------
    //     // let friendList = defaultFrinedList.payload
    //     // store.dispatch(GetFriendList(friendList))
    //     // friendList.forEach((frined) => {
    //     //     let user //= new User()
    //     //     user = {
    //     //         userId: frined.friendInfo.userId,
    //     //         userName: frined.friendInfo.userName,
    //     //         avatar: frined.friendInfo.avatar,
    //     //         phone: frined.friendInfo.phone,
    //     //     }
    //     //     store.dispatch(AddUserCache(user))
    //     // })
    //     //------------------------------------------------------------------------
    //     //------------------------------------------------------------------------
    //     console.log(e)
    // })
}
/**调用后台接口 读取好友请求*/
export const getfriendapp = (user) => {
    if (!user) {
        user = store.getState().userReducer.get('user').toJS()
    }
    // console.log(typeof(user.userId))
    // if (typeof user.userId === "string") {
    //     user.userId = Number(user.userId)
    // }
    axios.get(`${global2.serviceUrl.chat}/apply/user/${user.userId}`).then((data) => {
        let applylist = data.data.payload
        store.dispatch(GetFriendApplication(applylist))
    }).catch((e) => {

    })
}
//排序
const sortName = (data) => {
    data.sort((a, b) => {
        if (a.firstLetter > b.firstLetter) return 1
        else return -1
    })
}
const getFirstChar = (data) => {
    // debugger
    return data.map((item, index) => {
        let Letter = pinyin(item.friendInfo.userName.substring(0, 1), {
            style: pinyin.STYLE_FIRST_LETTER,
        });
        let firstLetter = Letter[0][0].toUpperCase();
        item.friendInfo.firstLetter = firstLetter
        return item.friendInfo
    });
}
// ****************************************************************
// *******   ********  *******  **************************   ******
// **   ***  ********   ******          *        *   *****   ******
// ***          ****     ******  **   *****   **     *           **
// ****         **   **   *********   *****          **         ***
// *    *       *                        *   *       *****   ******
// **        ***  ************  ***   ****  *                     *
// **        ****           **  ***   ***            ****    *  ***
// **     *  *  ****   *******  *       ****   *     **          **
// **          ****      *****     **   ****   ***   *         ****
// **   **     ***   ***  ****          ***   ****   * **        **
// **      **   **         ***  *  **   *    ****    ***   ****   *
// ****************************************************************
/**
 * 调用后台接口 读取会话列表   外加历史记录         此前已经从本地读取了messagelist到redux
 */
export const getTalkListOnline = (userId) => {
    return new Promise((resolve, reject) => {
        if (!userId) {
            userId = store.getState().userReducer.get('user').toJS().userId
        }
        customlog('调用后台接口 读取会话列表', 'start')
        let messageList = store.getState().messageReducer.get('messageList').toJS()
        axios.get(`${global2.serviceUrl.chat}/contact/${userId}`)
            .then((data) => {
                let talkList = data.data.payload
                // .更新聊天室列表     
                customlog('成功读取会话列表', 'end')
                console.log(talkList)
                talkList && talkList.forEach((element) => {    //添加到前端
                    //     // if (element.senderId === userId) {
                    console.log("会话列表元素：", element);
                    let chat = talkEntityRec2talkEntity(element)
                    store.dispatch(AddTalkList(chat))
                    if (chat.type === 'public') {
                        store.dispatch(ChangeActiveRoomName(chat))
                    }
                    // // 从云端拉取聊天记录-------------------------------------------------
                    let roomMessageList = messageList[chat.roomId] || [] //redux中读取消息
                    let lastLocalMessageTime = new Date(0)
                    let roomlastMsg = {}
                    if (roomMessageList && roomMessageList.length > 0) {
                        roomlastMsg = roomMessageList[roomMessageList.length - 1]
                        lastLocalMessageTime = roomlastMsg.time
                    }
                    // customlog(`判断房间${chat.roomId}有无最新消息`, 'start')
                    if (new Date(chat.lastMsgTime).getTime() > new Date(lastLocalMessageTime).getTime() + 10) {

                        if (element.lastMessage !== roomlastMsg.content) {
                            customlog(chat.roomId + '有最新消息,开始读取', 'start')
                            getmessagehistory(chat, (data) => {
                                console.log("后端获取历史消息：", data);
                                let msl = data.data.payload
                                for (let index = 0; index < msl.length; index++) {
                                    const msg = msl[index];
                                    let time = new Date(msg.createTime)
                                    if (time.getTime() > new Date(lastLocalMessageTime).getTime()) {
                                        let mess = historyMessage2LocalMessage(msg)
                                        console.log(mess);
                                        dispatchmessage(mess)
                                    }
                                }
                                customlog(chat.roomId + '最新消息,读取完成', 'end')
                            })
                        }
                    }
                    //------------------------------------------------------------------
                });
                resolve(talkList)
            }).catch((e) => {
            // debugger
            console.log('读取会话列表失败 原因是 ' + e, 'end')
            // let talkList = defaultTailList.payload
            // // .更新聊天室列表
            // talkList && talkList.forEach(element => {
            //     let chat = talkEntityRec2talkEntity(element)
            //     store.dispatch(AddTalkList(chat))
            // });
            reject("读取会话列表失败");
        })
    })


}
/**
 * 读取历史消息
 * @param {} chat
 * @param {*} callback
 */
const getmessagehistory = (chat, callback) => {
    let user = store.getState().userReducer.get('user').toJS()
    // if (chat.type === 'public')
    axios.get(`${global2.serviceUrl.chat}/message/${chat.type}2`, {
        params: {
            senderId: chat.receiverId,
            receiverId: user.userId,
            groupId: chat.receiverId,
            time: 2000
        }
    }).then((data) => {
        // debugger

        callback(data)
    }).catch((e) => {
        message.error(e)
    })
}

/**消息对象 转换      历史记录消息----》 redux保存的消息*/
export function historyMessage2LocalMessage(msg) {
    let user = store.getState().userReducer.get('user').toJS()
    let mess = {
        content: msg.content,
        type: msg.contentType,
        roomId: undefined,
        receiverId: msg.receiverId,
        time: msg.createTime,
        userId: msg.senderId,
        messageId: msg.serial,
        contactType: msg.messageType
    }
    let roomId
    if (user.userId === mess.receiverId) {
        roomId = mess.userId
    } else {
        roomId = mess.receiverId
    }
    switch (mess.contactType) {
        case 'public':
            mess.roomId = '/group/' + roomId;
            break;
        case 'private':
            mess.roomId = '/private/' + roomId;
            break;
    }
    return mess
}

/**消息会话对象 转换    redux保存的消息---------》redux保存会话的格式*/
export function message2talkEntity(mess) {
    let talkEntity = {
        chatName: "",//光从消息中无法得知，需要后续添加
        avatar: '',//光从消息中无法得知，需要后续添加
        messageId: mess.messageId,//光从消息中无法得知，需要后续添加
        type: mess.contactType,
        roomId: mess.roomId,
        lastMsg: mess.type === 'message' ? '系统消息' : mess.type === 'text' ? mess.content : mess.type === 'img' ? '[图片]' : mess.type === 'file' ? '[文件]' : '',
        lastMsgTime: mess.time,
        receiverId: mess.receiverId
    }
    return talkEntity
}

/**会话对象 转换 */
export function talkEntityRec2talkEntity(element) {
    // console.log(element);
    let chat = {
        type: element.contactType,
        receiverId: element.receiverId
    }
    switch (chat.type) {
        case 'public':
            chat.roomId = '/group/' + element.receiverId;
            break;
        case 'private':
            chat.roomId = '/private/' + element.receiverId;
            break;
    }
    let content
    if (!element.lastMessage) {
        element.lastMessage = ''
    }
    chat.chatName = element.contactName
    chat.avatar = element.contactAvatar
    chat.serial = element.serial
    chat.lastMsg = element.lastMessageType === 'message' ? '系统消息' : element.lastMessageType === 'text' ? element.lastMessage : element.lastMessageType === 'img' ? '[图片]' : element.lastMessageType === 'file' ? '[文件]' : ''
    chat.lastMsgTime = element.lastMessageTime
    return chat
}

